import React from 'react';

const Customer = () => {
    return (
        <div>
            <h1>This is customer page</h1>
        </div>
    );
};

export default Customer;
